// extracted by mini-css-extract-plugin
export default {"back-arrow":"style_back-arrow__m0mXN","header-style":"style_header-style__67JZ3","card-style":"style_card-style__HQUL2"};